<template >
  <v-list-item v-on="rowClickEnabled && item.rowClick ? { click: item.rowClick } : {}">
    <v-list-item-content >
      <v-list-item-title>
        {{item.defectReport.title}}</v-list-item-title>
      <v-list-item-subtitle>{{target}} </v-list-item-subtitle>
      <v-list-item-subtitle>{{item.defectReport.status | defectReportStatus}}  {{item.defectReport.created | dateTime}}</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action v-if="showActions && !!item.rowActions && !!item.rowActions.length > 0">
      <entity-table-row-end-action-menu :actions="item.rowActions"/>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import EntityTableRowEndActionMenu from '@/components/entity-crud/EntityTableRowEndActionMenu';
export default {
  name: 'DefectReportListItem',
  components: { EntityTableRowEndActionMenu },
  props:{
    item:{
      type: Object,
      required: true,
      validator: item => {
          return  !!item.defectReport;
      },
    },
    showActions:{
      type: Boolean,
    },
    rowClickEnabled:{
      type: Boolean,
    },
  },
  computed:{
     target(){
      if (this.item.defectReport.writeInDeviceName) {
        return this.item.defectReport.writeInDeviceName;
      }
      return this.$options.filters.device(this.item.defectReport.device);
    },
  },
};
</script>

<style scoped>

</style>
